export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/shareIcon.c60f19b1.svg","height":27,"width":24,"blurWidth":0,"blurHeight":0};